<template>
  <div class="item-price flex">
    <slot name="beforePrice" />
    <div v-if="price" class="price" :class="{ 'flex-row': inline }">
      <slot v-if="discount > 0 && show_discount" name="discount" :discount="discount">
        <div v-if="!inline" class="discount flex">{{ $t(getCheaperLabel(suggested_price), { x: discount }) }}</div>
        <div v-else class="discount">-{{ discount }}%</div>
      </slot>
      <Currency :amount="price" tag="div" />
    </div>
    <div v-if="suggested_price" class="ref-price text-shadow text-cfi">
      <span v-if="suggested_price_text" class="text">
        {{ $t(getPriceLabel(suggested_price)) }}: </span>
      <Currency :amount="suggested_price" />
    </div>
  </div>
</template>

<script setup>
import Currency from '@/component/body/Currency.vue';
import { computed } from 'vue';
import { getCheaperLabel, getPriceLabel } from '@/helper/steam.js';

const props = defineProps({
  price: {
    type: Number,
    default: 0,
  },
  discount: {
    type: Number,
    default: 0,
  },
  inline: {
    type: Boolean,
    default: false,
  },
  suggested_price: {
    type: Number,
    default: 0,
  },
  suggested_price_text: {
    type: Boolean,
    default: true,
  },
  show_discount: {
    type: Boolean,
    default: true,
  },
});

const discount = computed(() => {
  if (props.price && props.suggested_price) {
    return Math.min(Math.round((1 - props.price / props.suggested_price) * 100), 99);
  }
  return props.discount;
});
</script>
